import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';
import Icon from '@afosto/app-components-react/Icon';
import QuantityBox from '../QuantityBox';
import QuantityCounterContainer from './QuantityCounterContainer';
import styled from 'styled-components';
import translations from './translations';

const SuccessIcon = styled(Icon)`
  && {
    color: ${props => props.theme.palette.success.main};
  }
`;

const QuantityCounter = ({
  ContainerElement,
  onAll,
  onChange,
  onMinus,
  onPlus,
  quantity,
  quantityLabel,
  requested,
  requestedLabel,
  showAllButton,
  showCheckMark,
}) => {
  const intl = useIntl();

  const handleAll = () => {
    if (onAll) {
      onAll();
    }
  };

  return (
    <ContainerElement>
      <Box mr={2}>
        <QuantityBox
          color="default"
          quantity={requested}
          label={requestedLabel ?? intl.formatMessage(translations.properties.requested)}
        />
      </Box>

      <Box mr={2}>
        <QuantityBox
          color="primary"
          quantity={quantity}
          label={quantityLabel ?? intl.formatMessage(translations.properties.quantity)}
          onChange={onChange}
          onPlus={onPlus}
          onMinus={onMinus}
          allowEdit
        />
      </Box>

      <Box mt={3.5}>
        {showCheckMark && quantity === requested && (
          <Box width={56} height={56} display="flex" alignItems="center" justifyContent="center">
            <SuccessIcon icon={['fal', 'check']} />
          </Box>
        )}

        {showAllButton && quantity < requested && (
          <Fab color="secondary" style={{ width: 56, height: 56 }} onClick={handleAll}>
            <Icon icon={['fal', 'clipboard-check']} />
          </Fab>
        )}

        {showCheckMark && !showAllButton && quantity < requested && (
          <Box style={{ width: 56, height: 56 }} />
        )}
      </Box>
    </ContainerElement>
  );
};

QuantityCounter.propTypes = {
  ContainerElement: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.string]),
  onAll: PropTypes.func,
  onChange: PropTypes.func,
  onMinus: PropTypes.func,
  onPlus: PropTypes.func,
  quantity: PropTypes.number,
  quantityLabel: PropTypes.string,
  requested: PropTypes.number,
  requestedLabel: PropTypes.string,
  showAllButton: PropTypes.bool,
  showCheckMark: PropTypes.bool,
};

QuantityCounter.defaultProps = {
  ContainerElement: QuantityCounterContainer,
  onAll: undefined,
  onChange: undefined,
  onMinus: undefined,
  onPlus: undefined,
  quantity: 0,
  quantityLabel: undefined,
  requested: 0,
  requestedLabel: undefined,
  showAllButton: true,
  showCheckMark: true,
};

export default QuantityCounter;
